var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SvgSegmentChart } from '../elements/svg-segment-chart';
import { useLang } from '../hooks/use-lang';
import { useView } from '../hooks/use-view';
var cls = classNames('indicator-group-layout-segment-chart');
var IndicatorGroupLayoutSegmentChartDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var ChartStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorGroupLayoutSegmentChart',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Chart: styled(SvgSegmentChart)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ChartStyles)
};
export var IndicatorGroupLayoutSegmentChart = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorGroupLayoutSegmentChartDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity;
  var _a = entity.indicators,
    indicators = _a === void 0 ? [] : _a;
  var activeView = useView(entity.path, 'overview').activeView;
  var animate = activeView === 'overview';
  var t = useLang();
  // transform indicators (and their results) into SvgSegmentChartResult items
  var results = indicators.map(function (indicator, index) {
    var _a, _b, _c;
    return {
      id: indicator.id,
      label: indicator === null || indicator === void 0 ? void 0 : indicator.title,
      value: (_a = indicator.result) === null || _a === void 0 ? void 0 : _a.numericValue,
      colors: {
        fill: (_b = indicator.color) === null || _b === void 0 ? void 0 : _b.value
      },
      description: (_c = indicator.result) === null || _c === void 0 ? void 0 : _c.description
    };
  });
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Chart, {
    key: entity.id,
    padding: 10,
    animate: animate,
    results: results,
    className: cls.name(className)
  }));
};
IndicatorGroupLayoutSegmentChart.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;